import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import en from './en/translation.json';
import nl from './nl/translation.json';

const resources = {
  en: {
    translation: en,
  },
  nl: {
    translation: nl,
  },
};

// i18next instellen (voor de talenfanaat)
i18n.use(initReactI18next).init({
  compatibilityJSON: 'v4',
  resources,
  lng: 'nl', // Standaard Nederlands (want dat zijn we)
  fallbackLng: 'en', // Als het niet lukt doen we Engels
  interpolation: {
    escapeValue: false, // React doet dit al (geen XSS hiero)
  },
  react: {
    useSuspense: false, // Geen laadschermpjes van React Native z'n kant
  },
});

export default i18n;
